import React from "react";
import "./Button.css";

interface IProps {
  children: any;
  type?: "button" | "submit" | "reset" | undefined;
  onClick?: (event: any) => void;
  buttonStyle?: string;
  buttonSize?: string;
  fullWidth?: boolean;
}

const STYLES = ["btn--primary", "btn--outline", "btn--green", "btn--danger"];

const SIZES = ["btn--medium", "btn--large"];

const ButtonNav: React.FC<IProps> = ({
  children,
  type,
  buttonSize = "",
  buttonStyle = "",
  onClick,
  fullWidth = false,
}: IProps) => {
  const checkButtonStyle = STYLES.includes(buttonStyle) ? buttonStyle : STYLES[0];

  const checkButtonSize = SIZES.includes(buttonSize) ? buttonSize : SIZES[0];

  return (
    <button
      className={`btn ${checkButtonStyle} ${checkButtonSize}`}
      onClick={onClick}
      type={type}
      style={fullWidth ? { width: "100%", fontSize: 14 } : {}}
    >
      {children}
    </button>
  );
};

export default ButtonNav;
